const SET_WINDOW_SIZE = 'SET_WINDOW_SIZE'
const OPEN_FAQS = 'OPEN_FAQS'
const CLOSE_FAQS = 'CLOSE_FAQS'
const OPEN_CREDITS = 'OPEN_CREDITS'
const CLOSE_CREDITS = 'CLOSE_CREDITS'
const SET_MOBILE_VARIETY = 'SET_MOBILE_VARIETY'
const SET_IPHONE = 'SET_IPHONE'
const SET_STANDALONE = 'SET_STANDALONE'
const SET_ONBOARDING = 'SET_ONBOARDING'
const SET_SERVICE_WORKER_STATUS = 'SET_SERVICE_WORKER_STATUS'
const SET_DEMO_REQUEST = 'SET_DEMO_REQUEST'
const SET_INSTALL_PROMPT = 'SET_INSTALL_PROMPT'
const OPEN_TS_DIALOG = 'OPEN_TS_DIALOG'
const CLOSE_TS_DIALOG = 'CLOSE_TS_DIALOG'
const SET_BROWSER_TYPE = 'SET_BROWSER_TYPE'
const DEVICE_MATCH_BROWSER = 'DEVICE_MATCH_BROWSER'
const SET_SUGGESTED_BROWSER = 'SET_SUGGESTED_BROWSER'
const SET_NETWORK_STATUS = 'SET_NETWORK_STATUS'
const SET_ORIENTATION_ANGLE = 'SET_ORIENTATION_ANGLE'

import {
  Cache
} from 'aws-amplify'
const cacheConfig = {
  keyPrefix: 'fdi-mainmodule-'
};
const FDILocalStorage = Cache.createInstance(cacheConfig);

const state = {
  //orientationAngle: window.screen.orientation.angle,
  testing: true,
  onboarding: null,
  demoRequest: null,
  windowSize: {},
  faqDialog: false,
  creditsDialog: false,
  tsDialog: false,
  mobileType: null,
  browserType: null,
  isIphone: null,
  serviceWorkerAvailable: false,
  userAgent: window.navigator.userAgent.toLowerCase(),
  standalone: ('standalone' in window.navigator) && (window.navigator.standalone),
  bottomNavIcons: {
    preloaded: false,
    images: {
      suspectsNavActive: null,
      suspectsNavInactive: null,
    }
  },
  installPrompt: null,
  suggestedBrowser: null,
  networkStatus: navigator.onLine ? "online" : "offline"
}

const mutations = {
  SET_WINDOW_SIZE(state, windowSize) {
    state.windowSize = windowSize
  },
  OPEN_FAQS(state) {
    state.faqDialog = true
  },
  CLOSE_FAQS(state) {
    state.faqDialog = false
  },
  OPEN_CREDITS(state) {
    state.creditsDialog = true
  },
  CLOSE_CREDITS(state) {
    state.creditsDialog = false
  },
  [SET_IPHONE]: (state, bool) => {
    state.isIphone = bool
  },
  [SET_MOBILE_VARIETY]: (state, type) => {
    state.mobileType = type
  },
  [SET_STANDALONE](state, bool) {
    state.standalone = bool
  },
  [SET_ONBOARDING](state, bool) {
    state.onboarding = bool
  },
  [SET_DEMO_REQUEST](state, bool) {
    state.demoRequest = bool
  },
  [SET_SERVICE_WORKER_STATUS]: (state, bool) => {
    state.serviceWorkerAvailable = bool
  },
  [SET_INSTALL_PROMPT]: (state, p) => {
    state.installPrompt = p
  },
  [OPEN_TS_DIALOG]: (state) => {
    state.tsDialog = true
  },
  [CLOSE_TS_DIALOG]: (state) => {
    state.tsDialog = false
  },
  [SET_BROWSER_TYPE]: (state, type) => {
    state.browserType = type
  },
  [DEVICE_MATCH_BROWSER]: (state, bool) => {
    state.deviceMatchBrowser = bool
  },
  [SET_SUGGESTED_BROWSER]: (state, browser) => {
    state.suggestedBrowser = browser
  },
  [SET_NETWORK_STATUS]: (state, status) => {
    state.networkStatus = status
  },
  // [SET_ORIENTATION_ANGLE]: (state, angle) => {
  //   state.orientationAngle = angle
  // }
}

const actions = {
  setNetworkListener({
    commit
  }) {
    function updateOnlineStatus(event) {
      var condition = navigator.onLine ? "online" : "offline";
      commit(SET_NETWORK_STATUS, condition)
    }

    window.addEventListener('online', updateOnlineStatus);
    window.addEventListener('offline', updateOnlineStatus);
  },
  clearMainCache() {
    FDILocalStorage.clear()
  },
  setSuggestedBrowser({
    commit
  }, browser) {
    commit(SET_SUGGESTED_BROWSER, browser)
  },
  deviceMatchBrowser({
    commit
  }, bool) {
    commit(DEVICE_MATCH_BROWSER, bool)
  },
  setBrowserType({
    commit
  }, type) {
    commit(SET_BROWSER_TYPE, type)
  },
  setWindowSize({
    commit
  }, windowSize) {
    commit(SET_WINDOW_SIZE, windowSize)
  },
  openFAQS({
    commit
  }) {
    commit(OPEN_FAQS)
  },
  closeFAQS({
    commit
  }) {
    commit(CLOSE_FAQS)
  },
  openTSDialog({
    commit
  }) {
    commit(OPEN_TS_DIALOG)
  },
  closeTSDialog({
    commit
  }) {
    commit(CLOSE_TS_DIALOG)
  },
  openCredits({
    commit
  }) {
    commit(OPEN_CREDITS)
  },

  closeCredits({
    commit
  }) {
    commit(CLOSE_CREDITS)
  },
  setMobileType({
    commit
  }, type) {
    commit(SET_MOBILE_VARIETY, type)
  },
  setIphone({
    commit
  }, bool) {
    commit(SET_IPHONE, bool)
  },
  setStandalone({
    commit
  }) {
    var standalone = ('standalone' in window.navigator) && (window.navigator.standalone)
    commit(SET_STANDALONE, standalone)
  },
  setInitialOnboarding({
    commit,
    state
  }) {
    return new Promise(async (resolve) => {
      if (state.serviceWorkerAvailable) {
        var onboarding = await JSON.parse(FDILocalStorage.getItem('onboarding', {
          callback: () => true
        }))
        commit(SET_ONBOARDING, onboarding)
        resolve({
          ok: true
        })
      } else {
        commit(SET_ONBOARDING, false)
      }
    })
  },
  setInitialDemoRequest({
    commit
  }) {
    return new Promise(async (resolve) => {
      if (state.serviceWorkerAvailable) {
        var demoRequest = await JSON.parse(FDILocalStorage.getItem('demo-request', {
          callback: () => true
        }))
        commit(SET_DEMO_REQUEST, demoRequest)
        resolve({
          ok: true
        })
      } else {
        commit(SET_DEMO_REQUEST, true)
        resolve({
          ok: true
        })
      }
    })
  },
  setDemoRequest({
    commit
  }, bool) {
    commit(SET_DEMO_REQUEST, bool)
    FDILocalStorage.setItem('demo-request', JSON.stringify(bool))
  },
  setOnboarding({
    commit
  }, bool) {
    commit(SET_ONBOARDING, bool)
    FDILocalStorage.setItem('onboarding', JSON.stringify(bool))
  },
  async checkForServiceWorker({
    commit
  }) {
    commit(SET_SERVICE_WORKER_STATUS, 'serviceWorker' in navigator)
  },
  clearLocal() {
    FDILocalStorage.clear()
  },
  // setOrientationAngle({
  //   commit
  // }, angle) {
  //   commit(SET_ORIENTATION_ANGLE, angle)
  // }
}

const getters = {
  appInnerHeight: state => state.windowSize.height,
  appInnerWidth: state => state.windowSize.width,
  faqDialog: state => state.faqDialog,
  tsDialog: state => state.tsDialog,
  creditsDialog: state => state.creditsDialog,
  isIos: (state) => /iphone|ipad|ipod/.test(state.userAgent),
  browserType: (state) => state.browserType,
  mobileType: state => state.mobileType,
  onboarding: state => state.onboarding,
  demoRequest: state => state.demoRequest,
  serviceWorkerAvailable: state => state.serviceWorkerAvailable,
  deferredPrompt: (state) => state.installPrompt,
  deviceMatchBrowser: (state) => state.deviceMatchBrowser,
  suggestedBrowser: (state) => state.suggestedBrowser,
  standalone: (state) => state.standalone,
  networkStatus: (state) => state.networkStatus,
  //orientationAngle: state => state.orientationAngle
}

const mainModule = {
  state,
  mutations,
  actions,
  getters
}

export default mainModule;